import React from 'react';
import {parse} from 'query-string';
import {useLocation, useHistory} from 'react-router-dom';
import ListView from './ListView';
import {useUsersStore} from '../UsersStore';

function ListContainer() {
  const location = useLocation();
  const history = useHistory();
  const {state: usersStore, dispatch} = useUsersStore();
  const [page, setPage] = React.useState(typeof parse(location.search).page === 'undefined' ? 0 : Number(parse(location.search).page));

  React.useEffect(() => {
    dispatch({type: 'FETCH_USERS'});
  }, [location]);

  function handlePageChange(_event, newPage = 0) {
    setPage(newPage);
    history.push(`${location.pathname}?page=${newPage}`);
  }

  function handleUnlinkSuccess() {
    if (usersStore.users.length === 1) {
      // If untied user was the last on the page, we go to previous page to not show an empty page
      handlePageChange({}, page - 1);
    } else {
      dispatch({type: 'FETCH_USERS'});
    }
  }

  return (
    <ListView
      page={page}
      onPageChange={handlePageChange}
      onUnlinkSuccess={handleUnlinkSuccess}
    />
  );
}

export default ListContainer;
